import script from "./ProjectManageUploadSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectManageUploadSetting.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectManageUploadSetting.vue?vue&type=style&index=0&id=b11296e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b11296e4"]])

export default __exports__